import {
  placementSaveResponseSchema,
  placementSkipResponseSchema,
  placementStateSchema,
  type SubmitPlacement,
} from '@mio/shared';
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '@/shared/api/client';
import { homeSummaryQuery } from '@/shared/api/queries/home';
import { programKeys } from '@/shared/api/queries/program';

export const placementQuery = queryOptions({
  queryKey: ['learner', 'placement'] as const,
  queryFn: ({ signal }) => apiRequest('/me/placement', placementStateSchema, { signal }),
  staleTime: 5 * 60_000,
});

export function usePlacement(enabled = true) {
  return useQuery({ ...placementQuery, enabled });
}

/** Saving a path changes the recommended next activity everywhere, so the program and home refresh. */
export function useSubmitPlacement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SubmitPlacement) =>
      apiRequest('/me/placement', placementSaveResponseSchema, { method: 'PUT', body: input }),
    onSuccess: (result) => {
      queryClient.setQueryData(placementQuery.queryKey, {
        questionnaireVersion: result.placement.questionnaireVersion,
        placement: result.placement,
      });
      void queryClient.invalidateQueries({ queryKey: programKeys.full() });
      void queryClient.invalidateQueries({ queryKey: homeSummaryQuery.queryKey });
    },
  });
}

export function useSkipPlacement() {
  return useMutation({
    mutationFn: () =>
      apiRequest('/me/placement/skip', placementSkipResponseSchema, { method: 'POST' }),
  });
}
